'use client';
import { useRef } from 'react';
import './StorylaneHero.scss';

const StorylaneHero = ({link}) => {
	const ref = useRef(null);

	return (
		<section
			ref={ref}
			id='platform-walkthrough'
			className='platform-storylane sl-visible'
			style={{
				width: '100%',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				padding: '60px 20px',
				margin: '0',
				marginTop: 'calc(-100vh + 400px)',
				position: 'relative',
				zIndex: 5,
				boxSizing: 'border-box',
				backgroundColor: 'transparent',
			}}
		>
			<div
				style={{
					width: '100%',
					maxWidth: '1280px',
					position: 'relative',
					borderRadius: '16px',
					overflow: 'hidden',
					border: '2px solid rgba(52, 149, 219, 0.6)',
					boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
					backgroundColor: '#1a1a1a'
				}}
			>
				<div
					className='sl-embed'
					style={{
						position: 'relative',
						paddingBottom: 0,
						width: '100%',
						height: 'calc(100vh - 185px)',
						transform: 'scale(1)'
					}}
				>
					<iframe
						title='Cylerian Storylane demo'
						loading='lazy'
						className='sl-demo'
						src={link}
						name='sl-embed'
						allow='fullscreen'
						allowFullScreen
						tabIndex={0}
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							border: 'none',
							margin: 0,
							padding: 10,
							pointerEvents: 'auto',
							zIndex: 2
						}}
					/>
				</div>
			</div>
		</section>
	);
};

export default StorylaneHero;
